export class Report {
  reportId: string;
  vertical: number;
  reportName: string;
  template: string;
  user: string;
  description: string;
  language: string;
  isActive: boolean;
}
